<template>
  <div
    class="w-full h-full flex gap-2 p-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] text-[var(--text)]"
  >
    <div class="flex flex-col gap-2">
      <div class="flex gap-2 items-center">
        <h1>Adicionar {{ data.title }}</h1>

        <!-- <AppButton :visibility="true" :font_size="11" color="#006698"
                text="Limpar" @click.prevent="clear_inputs" /> -->
        <!-- <button class=" bg-transparent border border-white-500 p-1" @click.prevent="clear_inputs">Limpar</button> -->
      </div>
      <AppButton
        :visibility="true"
        emitType="select"
        @select="clear_inputs"
        :font_size="12"
        color="#006698"
        text="Limpar"
      />
      <div v-for="(value, key) in item" :key="key">
        <!-- <div v-if="Array.isArray(value) && key ==='tipos'" class="flex flex-col">
                    <label for="tipos">{{ key }}:</label>
                    <select v-model="item.tipo" @change="updateTipo" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40" placeholder="teste">
                        <option v-for="option in value" :key="option.id" :value="option.id">{{ option.nome }}</option>
                    </select>
                </div> -->

        <input
          v-if="key === 'data_inicio' || key === 'data_validade'"
          class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-full lg:max-w-40 "
          type="date"
          v-model="item[key]"
          placeholder="YYYY-MM-DD"
        />

        <!-- Default input for other fields -->
        <input
        style="background-color: var(--label);"
          v-else
          class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-full lg:max-w-40"
          :type="getInputType(value)"
          v-model="item[key]"
          :placeholder="key"
        />
      </div>
      <div v-for="(value, key) in types" :key="key">
        <div v-if="Array.isArray(value)" class="flex flex-col">
          <label for="tipos">{{ key }}:</label>
          <select
          style="background-color: var(--label);"
            v-model="set_data_copy[key].id"
            @change="updateTipo"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"
            placeholder="teste"
          >
            <option v-for="option in value" :key="option.id" :value="option.id">
              {{ option.nome }}
            </option>
          </select>
        </div>
      </div>

      <button
        class="bg-[#ff9b05] text-white rounded-[10px] lg:max-w-40"
        @click.prevent="add_data"
      >
        {{ data_create ? "Adicionar" : "Atualizar" }}
      </button>
      <button
        v-if="!data_create"
        class="bg-[#a82222] text-white rounded-[10px] lg:max-w-40"
        @click.prevent="delete_data"
      >
        eliminar
      </button>
    </div>

    <div class="flex flex-col gap-2 p-2 w-full">
      <AppButton
      style="color: var(--icon);"
        class="self-end text-[var(--text)]"
        v-bind:visibility="true"
        left_icon="fa-regular fa-circle-xmark fa-xl"
        emitType="close"
        @close="close"
        :width="23"
        :height="23"
      />

      <div v-if="with_address" class="flex gap-2 items-center">
        <label for="address" class="">Endereço:</label>
        <h3 class="text-[#ff9b05]">
          {{
            address_is_empty(address) ? "Não Atribuído" : address.pais + ",.."
          }}
        </h3>
        <!-- <input class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"  type="text" v-model="address" placeholder="Endereço:"> -->
        <AppButton
          v-bind:visibility="true"
          :font_size="8"
          color="#9797EF"
          left_icon="fa-solid fa-pen-to-square"
          text="Mapa"
          emitType="select"
          @select="show_map = true"
        />
      </div>

      <AppAddressMap
        v-if="show_map"
        :initialAddress="address"
        @close="close_map"
        @save="update_address"
      />

      <AppTable
        visibility="true"
        :show="!show_map"
        :table_data="items"
        :table_title="data.title"
        @row-clicked="select_data"
        :show_multiSelect="false"
      />

      <!-- <AppTable visibility="true" :show="!show_map"
                    :table_data="items" :table_title="title" @row-clicked="select_data"
                    :confirmationProps="{show:true, message:`selecionar ${entity_type}?`}"
            /> -->
    </div>
  </div>
</template>

<script>
import { id as loggedID } from "@/extraData";
import axios from "axios";
import AppTable from "./tables/table.vue";
import AppButton from "./updated/button.vue";
import AppAddressMap from "./addressMap.vue";
import { toast } from "vue3-toastify";

export default {
  name: "genericCRUD",
  components: {
    AppButton,
    AppTable,
    AppAddressMap,
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    model: {
      type: Object,
    },
    types: {
      type: Object,
      default: {},
    },
    set_data: {
      type: Object,
      default: {},
    },
    set_id: {
      type: Object,
      default: {},
    },

    with_address: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loggedID: loggedID,
      items: [],
      set_data_copy: JSON.parse(JSON.stringify(this.set_data)),
      item: JSON.parse(JSON.stringify(this.model)),
      data_create: true,
      baseURl: process.env.VUE_APP_URL_BASE,
      address: {
        pais: "",
        morada: "",
        codigoPostal: "",
        freguesia: "",
        localidade: "",
        latitude: "",
        longitude: "",
        concelho: "",
        distrito: "",
      },
      show_map: false,

      // entity_type_uppercase: this.data.entity_type.charAt(0).toUpperCase() + this.data.entity_type.slice(1),
      // data
    };
  },
  created() {
    // this.create_url= `${this.baseURl}/api/v1/${this.entity_type}/registrar/`
    // console.log("create_url:",this.create_url)
    // this.select_url= `${this.baseURl}/api/v1/${this.entity_type}/`,
    // console.log("select_url:",this.select_url)
    // this.select_owner_url= `${this.baseURl}/api/v1/${this.owner.type}/${this.owner.id}/?${this.entity_type}_only=true/`,
    // console.log("select_owner_url:",this.select_owner_url)
    // this.update_url= `${this.baseURl}/api/v1/${this.entity_type}/editar`,
    // console.log("update_url:",this.update_url)
    // this.delete_url= `${this.baseURl}/api/v1/${this.entity_type}/eliminar`,
    // console.log("delete_url:",this.delete_url)

    console.log("item", this.item);
    this.get_datas();
  },

  methods: {
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },

    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },

    getInputType(value) {
      return typeof value === "number" ? "number" : "text";
    },

    async get_datas() {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      // if(this.items){
      //     this.items = []
      // }

      this.items = await this.select_all(this.data.rotas.select_all_url);

      if (this.data.entity_type == "armazem") {
        const filtered_items = this.items.map((obj) =>
          Object.fromEntries(
            Object.entries(obj).filter(([key]) =>
              ["id", "nome", "descricao", "tipo", "zona", "endereco"].includes(
                key
              )
            )
          )
        );
        filtered_items.forEach((item) => {
          if (item.endereco) {
            item.endereco = item.endereco.pais ? item.endereco.pais : "N/A";
          }
        });
        this.items = filtered_items.sort((a, b) => a.id - b.id);
      } else this.items = this.items.sort((a, b) => a.id - b.id);
    },

    async add_data() {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      for (let key in this.set_data_copy) {
        if (this.set_id.hasOwnProperty(key)) {
          this.item[this.set_id[key]] = this.set_data_copy[key].id;
        }
      }
      if (!this.data.owner.mulTitable && this.item.id == 0) {
        this.item[this.data.owner.key_name] = this.data.owner.id;
      }

      console.log("item to crete:", this.item);

      if (this.item.id == 0) {
        console.log("inside create", this.item);
        delete this.item.id;
        const res = await this.create(this.item, this.data.rotas.create_url);
        if (res) {
          console.log("entity created:", res);
          if (this.with_address) {
            await this.manage_entity_address(
              "create",
              res,
              this.data.entity_type
            );
          }
          console.log("item created:", res);
          if (
            this.data.owner.multiTable &&
            this.data.owner &&
            !isEmptyObject(this.data.owner)
          ) {
            await this.create_owner_entity(res);
          } else {
            toast.success(`${this.data.entity_type} criado com sucesso!`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            });
          }
          this.clear_inputs();
          await this.get_datas();
        }
      } else {
        const res = await this.update(
          `${this.data.rotas.update_url}/${this.item.id}/`,
          this.item
        );
        if (res) {
          console.log("entity updated:", res);
          if (this.with_address) {
            await this.manage_entity_address(
              "update",
              res,
              this.data.entity_type
            );
          }
          this.clear_inputs();
          toast.success(`${this.data.entity_type} atualizado com sucesso!`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          await this.get_datas();
        }
      }
    },

    async select_data(item) {
      console.log("item selected:", item);
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      console.log("table item:", item);

      const entity = await this.select(
        `${this.data.rotas.select_url}${item.id}/`
      );
      console.log("entity:", entity);
      this.data_create = false;
      const current_item = JSON.parse(JSON.stringify(entity));

      for (let key in this.set_data_copy) {
        if (current_item.hasOwnProperty(key)) {
          this.set_data_copy[key] = current_item[key];
        }
      }

      // if(current_item.tipo){
      //     current_item.tipos = this.model.tipos;
      //     current_item.tipo=current_item.tipo.id
      // }

      if (current_item.endereco) {
        this.address = JSON.parse(JSON.stringify(current_item.endereco));
        if (isEmptyObject(this.address)) {
          this.address.id = 0;
        }
        console.log("address:", this.address);
      }

      //this.deleteKeys(current_item);
      for (let key in current_item) {
        if (!this.item.hasOwnProperty(key)) {
          delete current_item[key];
        }
      }

      console.log("table final item:", current_item);
      this.item = JSON.parse(JSON.stringify(current_item));
    },

    async delete_data() {
      const res = await this.remove(
        `${this.data.rotas.delete_url}/${this.item.id}/`
      );
      if (res) {
        console.log("item deleted:", res);
        toast.success(`${this.data.entity_type} eliminado com sucesso!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.clear_inputs();

        await this.get_datas();
      }
    },

    clear_inputs() {
      this.item = JSON.parse(JSON.stringify(this.model));
      this.set_data_copy = JSON.parse(JSON.stringify(this.set_data));

      this.address = {
        pais: "",
        morada: "",
        codigoPostal: "",
        freguesia: "",
        localidade: "",
        latitude: "",
        longitude: "",
        concelho: "",
      };
      this.data_create = true;
    },

    close() {
      this.$emit("close");
    },

    updateTipo(event) {
      console.log("choice:", event.target.value);
      // this.item['tipo'] = event.target.value;
      console.log(this.item["tipo"]);
    },

    async create_owner_entity(data) {
      //console.log(`${this.owner.type} ${this.entity_type} to create:`,data)
      const create_data = {};
      create_data[this.data.key_name] = data.id;
      create_data[this.data.owner.key_name] = this.data.owner.id;

      // if(data['tp' + this.entity_type_uppercase + '_id'])
      //     create_data.tipo_id=data['tp' + this.entity_type_uppercase + '_id']

      const res = await this.create(
        create_data,
        this.data.owner.rotas.create_url
      );
      if (res) {
        console.log("fornecedor contacto created", res);
        toast.success(
          `${this.data.entity_type} do/a ${this.data.owner.type} criado com sucesso`,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          }
        );
      } else {
        toast.error(`Erro ao adicionar ${this.data.entity_type}`, {
          autoClose: 1000,
        });
      }
      // this.fornecedor_contactos.push(data);
    },

    update_address(data) {
      console.log("parent address:", data);
      this.address = JSON.parse(JSON.stringify(data));
      this.close_map();
    },

    close_map() {
      this.show_map = false;
    },

    deleteKeys(obj) {
      Object.keys(obj).forEach((key) => {
        if (
          key.includes("tp") ||
          key.includes("_id") ||
          key.includes("foto") ||
          key.includes("endereco")
        ) {
          delete obj[key];
        }
      });
    },

    async manage_entity_address(action, entity, entity_name) {
      console.log("endereco to create/update:", this.address);
      console.log("entity to update:", entity);
      if (action == "create") {
        delete this.address.id;
        const res = await this.create(
          this.address,
          `${this.baseURl}/api/v1/endereco/registrar/`
        );
        if (res) {
          console.log("endereco created:", res);
          const updated_entity = await this.update(
            `${this.baseURl}/api/v1/${entity_name}/editar/${entity.id}/`,
            { nome: entity?.nome ? entity.nome : "", endereco_id: res.id }
          );
          if (updated_entity) {
            console.log(`${entity_name} updated`, updated_entity);
          }
          // console.log("endereco created",res)
          // toast.success("Endereço criado com sucesso",{
          //     position: toast.POSITION.TOP_CENTER,
          //     autoClose: 1000,
          // });
          // this.fornecedor_setData.endereco=res;
          // this.close_address();
        } else {
          toast.error("Erro ao criar endereço", {
            autoClose: 1000,
          });
        }
      } else if (action == "update") {
        console.log(`${entity_name} to update:`, entity);
        if (this.address.id == 0) {
          const res = await this.create(
            this.address,
            `${this.baseURl}/api/v1/endereco/registrar/`
          );
          if (res) {
            console.log("endereco created:", res);
            const updated_entity = await this.update(
              `${this.baseURl}/api/v1/${entity_name}/editar/${entity.id}/`,
              { nome: entity?.nome ? entity.nome : "", endereco_id: res.id }
            );
            if (updated_entity) {
              console.log(`${entity_name} updated`, updated_entity);
            } else {
              toast.error(`Erro ao Criar endereço do/a ${entity_name}`, {
                autoClose: 1000,
              });
            }
          } else {
            toast.error("Erro ao Criar endereço", {
              autoClose: 1000,
            });
          }
        } else {
          const res = await this.update(
            `${this.baseURl}/api/v1/endereco/editar/${this.address.id}/`,
            this.address
          );
          console;
          if (res) {
            console.log("endereco updated", res);
          } else {
            toast.error("Erro ao atualizar endereço", {
              autoClose: 1000,
            });
          }
        }
      }
    },
    address_is_empty(address) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      if (isEmptyObject(address)) {
        return true;
      }
      return Object.values(address).every((x) => x === null || x === "");
    },
  },

  watch: {
    // data: {
    //     handler() {
    //         this.items = [...this.data]
    //     },
    //     deep: true
    // },
    // model: {
    //     handler() {
    //         // console.log('cart updated')
    //         this.item = JSON.parse(JSON.stringify(this.model))
    //     },
    //     deep: true
    // }
  },
};
</script>

<style></style>
